const BookBuyApi=[
    {
        id:1,
        logo:"fas fa-film",
        info1:"Movie",
        info2:"Tickets",
        info4:"fas fa-angle-right"
    },
    {
        id:2,
        logo:"fa fa-plane",
        info1:"Flight",
        info2:"Tickets",
        info4:"fas fa-angle-right"
    },
    {
        id:3,
        logo:"far fa-bus-alt",
        info1:"Bus",
        info2:"Tickets",
        info4:"fas fa-angle-right"
    },
    {
        id:4,
        logo:"fas fa-subway",
        info1:"Train",
        info2:"Ticket",
        info4:"fas fa-angle-right"
    },
    {
        id:5,
        logo:"fas fa-motorcycle",
        info1:"Car &",
        info2:"Bikes",
        info4:"fas fa-angle-right"
    },
    {
        id:6,
        logo:"fas fa-cubes",
        info1:"Invest In",
        info2:"Stocks",
        info4:"fas fa-angle-right"
    },
    
   
]


export default BookBuyApi